import { REGISTER_ME_QUERY, REGISTER_ME_UPDATE, REGISTER_ME_ERROR} from '../Actions/RegisterMe.action';

const defaultState = {
    fields: [],
}

export const registerMe = (state = defaultState, action) => {
    switch (action.type) {
        case REGISTER_ME_ERROR:
        case REGISTER_ME_QUERY:
        case REGISTER_ME_UPDATE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}
